/**
 * Recursively filters arrays in the payload, returning only objects with isSelected === true.
 * Handles nested objects and arrays. Preserves primitive values and Date objects.
 */
export function getSelectedFromArrays<T>(input: T): T {
  if (Array.isArray(input)) {
    if (
      input.length > 0 &&
      typeof input[0] === "object" &&
      input[0] !== null &&
      "isSelected" in input[0]
    ) {
      return input.filter((item) => item.isSelected) as unknown as T;
    }
    return input.map((item) => getSelectedFromArrays(item)) as unknown as T;
  }
  // Preserve Date objects
  if (input instanceof Date) {
    return input;
  }
  // Preserve null
  if (input === null) {
    return input;
  }
  // Only recurse into plain objects
  if (
    typeof input === "object" &&
    Object.prototype.toString.call(input) === "[object Object]"
  ) {
    const result: Record<string, unknown> = {};
    for (const key in input) {
      result[key] = getSelectedFromArrays(
        (input as Record<string, unknown>)[key]
      );
    }
    return result as T;
  }
  // Preserve primitives (string, number, boolean, undefined)
  return input;
}
